var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileCommentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 21.7656C17.3456 21.7656 21.375 17.7362 21.375 12.7656C21.375 7.79506 17.3456 3.76562 12.375 3.76562C7.40444 3.76562 3.375 7.79506 3.375 12.7656C3.375 14.2533 3.73593 15.6566 4.375 16.8928L3.375 21.7656L8.2478 20.7656C9.48404 21.4047 10.8874 21.7656 12.375 21.7656Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.875,
    y: 12.7656,
    width: 0.01,
    height: 0.01,
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.375,
    y: 12.7656,
    width: 0.01,
    height: 0.01,
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.875,
    y: 12.7656,
    width: 0.01,
    height: 0.01,
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCommentIcon);
export default __webpack_public_path__ + "static/media/profileCommentIcon.e63d6fb52556ac6996615a0524231c57.svg";
export { ForwardRef as ReactComponent };